import { Company } from "@/schema/Company";
import { Document } from "@/schema/Document";
import CompanyCard from "@/src/_components/CompanyCard";
import DocumentTable from "@/src/console/(auth)/_components/DocumentTable";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

interface Props {
  company: Company;
  submittedAt: Date;
  submittedBy: string;
  documents: Document[];
}

function AssessmentInfoPanel({
  company,
  submittedAt,
  submittedBy,
  documents,
}: Props) {
  const { t } = useTranslation();
  return (
    <div className=" flex flex-col px-4 py-6">
      <p className=" text-lg font-bold text-cool-gray-700">
        {t("assessment-information")}
      </p>
      <div className=" flex flex-row space-x-5 mt-2 mb-4">
        <div className=" text-sm font-normal text-cool-gray-700 flex flex-row">
          {t("submitted")}:
          <span className=" font-medium ml-1">
            {format(submittedAt, t("date-time-format"))}
          </span>
        </div>
        <div className=" text-sm font-normal text-cool-gray-700 flex flex-row">
          {t("submitted-by")}
          <span className=" font-medium ml-1">{submittedBy}</span>
        </div>
      </div>
      <CompanyCard company={company} />
      <p className=" text-lg font-bold text-cool-gray-700 pt-8 pb-4">
        {t("company-documents")}
      </p>
      <DocumentTable data={documents} />
    </div>
  );
}

export default AssessmentInfoPanel;
